import { axios } from "@/libraries/axios";
import type {
	CreateCaseEncounterPayload,
	GetEncounterResponseType,
} from "@/types";
import type { AxiosRequestConfig } from "axios";

class EncounterService {
	async detail(id: number, options?: AxiosRequestConfig) {
		try {
			const res = await axios.get<GetEncounterResponseType>(
				`/api/v1/encounters/${id}`,
				options,
			);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}

	async createCase(payload: CreateCaseEncounterPayload) {
		try {
			const { encounterId, case: casePayload } = payload;
			const res = await axios.post(`/api/v1/encounters/${encounterId}/cases`, {
				case: casePayload,
			});
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}
}

export const encounterService = Object.freeze(new EncounterService());
